export const PENDING_SAVE_TRIP_KEY = 'byway.pendingSaveTrip';

export type PendingSaveTrip = {
  tripId?: string;
  tripPageUrl?: string;
  startDate?: string;
  endDate?: string;
};
